export const baseApiUrl = process.env.REACT_APP_BASE_API_URL;
export const baseSVGExporterUrl = process.env.REACT_APP_BASE_SVG_EXPORTER_URL;
